import React, { useEffect, useRef, useState } from 'react'
import { DetailsPageConfig } from '../configuration'
import { ArrowRight, ArrowLeft } from '../icons'
import Button from '../Button'
import imageDesktop from './assets/images/desktop.jpg'
import imageMobile from './assets/images/mobile.jpg'
import styles from './Dettagli.module.sass'
import AssignId from '../AssignId'
import VisibilitySensor from '../VisibilitySensor'

export default function Dettagli() {

  const items = [
    { 
      key: DetailsPageConfig.key, 
      intro: DetailsPageConfig.intro, 
      title: DetailsPageConfig.title, 
      description: DetailsPageConfig.description,
      ctaLabel: DetailsPageConfig.ctaLabel,
      ctaIcon: <ArrowRight />,
      ctaIconPos: 'right',
    },
    { 
      key: DetailsPageConfig.key2, 
      intro:  DetailsPageConfig.intro2, 
      title: DetailsPageConfig.title2, 
      description: DetailsPageConfig.description2,
      ctaLabel: DetailsPageConfig.ctaLabel2,
      ctaIcon: <ArrowLeft /> ,
      ctaIconPos: 'left',
    },
  ]

  const [activeItem, setActiveItem] = useState(0)
  const [zoomed, setZoomed] = useState(false)
  const ref = useRef()
  const imageRef = useRef()
  
  const handleMouseMove = (e) => {
    if (ref?.current && imageRef?.current) {
      const imageCenterY = ref.current.offsetTop - window.scrollY + ref.current.offsetHeight / 2
      const imageCenterX = window.innerWidth / 2
      const shiftX = (imageCenterX - e.pageX) / 20
      const shiftY = (imageCenterY - (e.pageY - window.scrollY)) / 20
      imageRef.current.style.marginLeft = shiftX + 'px';
      imageRef.current.style.marginTop = shiftY + 'px';
    }
  }

  const renderItem = (index) => (
    <div className={`${styles.item} ${styles['item--top']} ${activeItem === index ? styles['item--active'] : ""}`}>
      <p className={styles.itemIntro}>{items[index].intro}</p>
      <p className={styles.itemTitle}>{items[index].title}</p>

	  <div className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: items[index].description }} />
	  
      <div className={styles.itemCtaBox}>
        <Button variant="ghost" label={items[index].ctaLabel} icon={items[index].ctaIcon} iconPos={items[index].ctaIconPos} onClick={() => setActiveItem((index + 1) % items.length)}/>
      </div>
    </div>
  )
  const renderItemMobile = (index) => (
    <Button 
      variant="ghost" 
      label={items[index].ctaLabel} 
      icon={items[index].ctaIcon} 
      iconPos={items[index].ctaIconPos} 
      onClick={() => setActiveItem((index + 1) % items.length)} 
      className={`${styles.itemCtaMobile} ${activeItem === index ? styles['itemCtaMobile--active'] : ""}`}
    />
  )

  useEffect(() => {
    function handleScroll() {
      setTimeout(function() {
        setZoomed(
          ref.current && 
          window.scrollY + window.innerHeight > ref.current.offsetTop + ref.current.offsetHeight * 0.75 &&
          window.scrollY < ref.current.offsetTop + ref.current.offsetHeight - ref.current.offsetHeight * 0.5
        )
      }, 1000)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={styles.root} onMouseMove={handleMouseMove} ref={ref}>
      <AssignId
        absolute
        y='-120px'
        yMobile='-80px'
        id={DetailsPageConfig.id}
      />
      <VisibilitySensor index={3} />
      <div>
        {renderItem(0)}
        <div className={`${styles.imageBox} ${zoomed ? styles['imageBox--zoomed'] : ""} ${activeItem === 0 ? styles['imageBox--left'] : activeItem === 1 ? styles['imageBox--right'] : ''} ${styles['imageBox--desktop']}`}>
          <img src={imageDesktop} ref={imageRef} />
        </div>
        <div className={`${styles.imageBox} ${zoomed ? styles['imageBox--zoomed'] : ""} ${activeItem === 0 ? styles['imageBox--left'] : activeItem === 1 ? styles['imageBox--right'] : ''} ${styles['imageBox--mobile']}`}>
          <img src={imageMobile} />
          {renderItemMobile(0)}
          {renderItemMobile(1)}          
        </div>
        {renderItem(1)}
      </div>
    </div>
  )
}
